import { IDmLoaiBangTotNghiep } from "../../model/response/category/IDmLoaiBangTotNghiep";
import { apiClient } from "../apiClient";
export const LOAI_BANG_TOT_NGHIEP_ENDPOINT = "loai-bang-tot-nghiep";
export const loaiBangTotNghiepApi = {
  SelectAll: () => apiClient.get(`${LOAI_BANG_TOT_NGHIEP_ENDPOINT}`),
  SelectLopByLoaiBang: (id: number) => apiClient.get(`${LOAI_BANG_TOT_NGHIEP_ENDPOINT}/${id}/lop`),
  SelectLopDaGan: () => apiClient.get(`${LOAI_BANG_TOT_NGHIEP_ENDPOINT}/lop-da-gan`),
  Insert: (data: IDmLoaiBangTotNghiep) => apiClient.post(`${LOAI_BANG_TOT_NGHIEP_ENDPOINT}`, data),
  Update: (id: number, data: IDmLoaiBangTotNghiep) => apiClient.put(`${LOAI_BANG_TOT_NGHIEP_ENDPOINT}/${id}`, data),
  GanLop: (id: number, dsStuLopId: number[]) => apiClient.post(`${LOAI_BANG_TOT_NGHIEP_ENDPOINT}/${id}/gan-lop`, dsStuLopId),
  GoLop: (id: number, dsStuLopId: number[]) => apiClient.post(`${LOAI_BANG_TOT_NGHIEP_ENDPOINT}/${id}/go-lop`, dsStuLopId),
  Delete: (id: number) => apiClient.delete(`${LOAI_BANG_TOT_NGHIEP_ENDPOINT}/${id}`),
};
